import { StarsButton } from '@ps/web-shared-components';
import React from 'react';
import { useDispatch } from 'react-redux';

import type { Dispatch } from '@swf/core/store';
import { useHomeGamesWidget } from '@swf/poker';

import { ModalRoutes } from '../../../types/common';
import AddIcon from '../../assets/plus.svg';

import { TXTCLI_Create_Club } from './SidebarCreateClubButton.messages.json';
import styles from './SidebarCreateClubButton.scss';

interface Props {
  loading?: boolean;
}

const CreateClubButton: React.FC<Props> = ({ loading = false }) => {
  const { modal } = useDispatch<Dispatch>();
  const { widgetId } = useHomeGamesWidget();

  return (
    <StarsButton
      data-testid="create-club-btn"
      className={styles.button}
      variant="text"
      size="large"
      icon={<AddIcon className={styles.icon} />}
      loading={loading}
      translation={TXTCLI_Create_Club}
      onClick={() =>
        modal.enqueue({
          path: ModalRoutes.createClub,
          locationState: { widgetId }
        })
      }
    />
  );
};

export default CreateClubButton;
